import {reqWithToken} from './requestHelper';

export async function getForm(id){
    return (await reqWithToken('api/pebooking/forms',{
        params: {id}
    })).data;
}

export async function sign(todo){
    return (await reqWithToken('api/pebooking/forms',{
        data: todo,
        method: 'post'
    })).data;
}

export async function signAll(ids){
    return (await reqWithToken('api/pebooking/forms/all',{
        data: ids,
        method: 'post'
    })).data;
}

export async function deny(todo){
    return (await reqWithToken('api/pebooking/forms/deny',{
        data: todo,
        method: 'post',

    })).data;
}

export async function cancel(id){
    return (await reqWithToken('api/pebooking/forms',{
        params: {id},
        method: 'patch'
    })).data;
}